import en from './locales/en.json';
import ru from './locales/ru.json';
import uk from './locales/uk.json';
import pl from './locales/pl.json';
import es from './locales/es.json';
import tr from './locales/tr.json';
import el from './locales/el.json';
import it from './locales/it.json';
import de from './locales/de.json';
import pt from './locales/pt.json';

export const resources = {
  en: { translation: en },
  ru: { translation: ru },
  uk: { translation: uk },
  pl: { translation: pl },
  es: { translation: es },
  tr: { translation: tr },
  el: { translation: el },
  it: { translation: it },
  de: { translation: de },
  pt: { translation: pt },
} as const;

export type Locale = keyof typeof resources;
export const DEFAULT_LOCALE: Locale = 'en';
export const SUPPORTED_LOCALES: Locale[] = ['en', 'ru', 'uk', 'pl', 'es', 'tr', 'el', 'it', 'de', 'pt'];

/** Normalize a language tag (e.g. `uk-UA`, `ru`) to a supported locale. */
export function resolveLocale(code: string | null | undefined): Locale {
  if (!code) return DEFAULT_LOCALE;
  const base = code.slice(0, 2).toLowerCase();
  return (SUPPORTED_LOCALES as readonly string[]).includes(base) ? (base as Locale) : DEFAULT_LOCALE;
}
